/** Modules of light margin the QR spec asks for around the symbol. */
export const QR_QUIET_ZONE = 4

export interface QrPath {
  /** SVG path data drawing every dark module, in module units. */
  d: string
  /** Width and height of the whole symbol, quiet zone included — the viewBox side. */
  size: number
}

/**
 * Turns a QR module matrix (`true` = dark) into one SVG path.
 *
 * Pure and renderer-agnostic on purpose: the web component and the React
 * Native app draw the same `d` into `viewBox="0 0 size size"`. Each run of
 * adjacent dark modules in a row becomes one rectangle, so a path stays a
 * fraction of the size of one square per module, and neighbouring squares
 * share edges exactly — no hairline seams between them at any scale.
 *
 * `quietZone` offsets every module by that many units and adds it to both
 * sides of `size`, so the margin is part of the drawing rather than left to
 * the page's padding — a scanner needs it to find the finder patterns.
 */
export function qrPath(
  matrix: readonly (readonly boolean[])[],
  quietZone: number = QR_QUIET_ZONE,
): QrPath {
  const parts: string[] = []
  matrix.forEach((row, y) => {
    let x = 0
    while (x < row.length) {
      if (!row[x]) {
        x++
        continue
      }
      const start = x
      while (x < row.length && row[x]) x++
      const run = x - start
      parts.push(`M${start + quietZone} ${y + quietZone}h${run}v1h-${run}z`)
    }
  })
  return { d: parts.join(''), size: matrix.length + quietZone * 2 }
}
